import { WOW } from "wowjs";

(function ($) {
    $(document).ready(function () {
        const wow = new WOW();

        wow.init();

        $(".menu-item-has-children")
            .find(".dropdown-toggle")
            .attr("data-toggle", "");

        let body = $("body");
        let desktopMenuBreakpoint = parseInt(
            $(":root").css("--desktop-menu-breakpoint")
        );
        let headerHeight = $("header").height();

        /**
         * Carousel - Pause slide videos when carousel is paused
         */
        let playPauseBtn = $(".carousel-block .carousel-control-cycle-toggle");

        $(playPauseBtn).on("click", function () {
            //get the current carousel block
            let theCarouselBlock = $(this).closest("section.carousel-block");
            //get the state of the button (play/pause)
            let pauseSelected = $(this).hasClass("oc-pause");

            //if the button is on pause, then pause all videos, else play all videos
            if (pauseSelected) {
                theCarouselBlock.find("video").trigger("pause");
            } else {
                theCarouselBlock.find("video").trigger("play");
            }
        });

        /**
         * Carousel - Set equal heights
         */
        function carouselEqualHeights() {
            $(".carousel-block").each(function () {
                var items = $(".carousel-item", this);
                let maxHeight = 0;

                // Show all slides
                $.each(items, function (i, slide) {
                    $(slide).addClass("active");
                });

                // Get the height of the tallest caption and save it
                // Desktop
                if (window.innerWidth >= 993) {
                    $.each(items, function () {
                        let caption = $(".carousel-caption", this);
                        let captionHeight = caption.outerHeight();

                        if (captionHeight > maxHeight) {
                            maxHeight = captionHeight + 250;
                        }
                    });

                    // Apply the max height to all captions
                    $.each(items, function () {
                        let caption = $(this);
                        caption.css("min-height", maxHeight + 150);

                        // Remove .active from all slides
                        $(this).removeClass("active");
                    });

                    // Mobile
                } else {
                    $.each(items, function () {
                        let caption = $(".carousel-caption", this);
                        let captionHeight = caption
                            .css("height", "auto")
                            .outerHeight();

                        if (captionHeight > maxHeight) {
                            maxHeight = captionHeight + 100;
                        }
                    });

                    // Apply the max height to all captions
                    $.each(items, function () {
                        let item = $(this);
                        item.css("height", maxHeight);

                        // Remove .active from all slides
                        $(this).removeClass("active");
                    });
                }

                // Add the active class back to the first slide
                $(
                    ".carousel-block .carousel-inner .carousel-item:first-of-type"
                ).addClass("active");
            });
        }

        // Run equal heights
        carouselEqualHeights();

        /**
         * Back to top button - scroll functionality
         */
        $("#back-to-top").on("click", function () {
            $("html, body").animate(
                {
                    scrollTop: 0,
                },
                400
            );

            return false;
        });

        /**
         * Header Body Padding
         */
        if ($(window).scrollTop() > 100) {
            $("body header").addClass("sticked").css("position", "fixed");
            $("#content").css("padding-top", headerHeight);
        } else {
            $("body header").removeClass("sticked").css("position", "sticky");
            $("#content").css("padding-top", 0);
        }
        $(window).scroll(function () {
            if ($(window).scrollTop() > 100) {
                $("body header").addClass("sticked").css("position", "fixed");
                $("#content").css("padding-top", headerHeight);
            } else {
                $("body header")
                    .removeClass("sticked")
                    .css("position", "sticky");
                $("#content").css("padding-top", 0);
            }
        });

        /**
         * Add class to body when sticky header is showing
         */
        if ($(window).scrollTop() > 100) {
            body.addClass("sticky-header");
            $("header").addClass("sticky");
        } else {
            body.removeClass("sticky-header");
            $("header").removeClass("sticky");
        }
        $(window).scroll(function () {
            if ($(window).scrollTop() > 100) {
                $("body").addClass("sticky-header");
                $("header").addClass("sticky");
            } else {
                $("body").removeClass("sticky-header");
                $("header").removeClass("sticky");
            }
        });

        /**
         * Mobile menu
         */

        $("header .js-mobile-menu-toggle").on("click", function () {
            $("body").toggleClass("no-scroll");
        });

        $("#header-navbar-menu-wrapper")
            .find(
                ".navbar-nav .menu-item.menu-item-has-children > .dropdown-menu"
            )
            .each(function () {
                if ($(window).width() < desktopMenuBreakpoint) {
                    $(this).addClass("mobile-menu-sub-level-panel");

                    let subLevelTitleElement = $("<h3>").html(
                        $(this).siblings(".nav-link").html().trim()
                    );

                    $(this).prepend(
                        $("<li>")
                            .addClass("menu-item sub-level-panel-heading")
                            .append(subLevelTitleElement)
                    );
                }
            });

        $("#header-navbar-menu-wrapper.navbar-collapse")
            .on("show.bs.collapse", function () {
                let headerBannerHeight = 0;

                $("body > header")
                    .children(":not(#header-search-overlay)")
                    .each(function () {
                        headerBannerHeight += $(this).outerHeight();
                    });

                if (!$("body > header").hasClass("sticky")) {
                    headerBannerHeight +=
                        parseInt($("html").css("margin-top")) -
                        $("html").scrollTop();
                }

                $(this).css(
                    "--mobile-menu-height",
                    $(window).outerHeight() - headerBannerHeight + "px"
                );

                $(this)
                    .children(".header-navbar-menu-inner-wrap")
                    .addClass("curr-level");
            })
            .on("hidden.bs.collapse", function () {
                $(this).find(".curr-level").removeClass("curr-level");

                $(this).find(".show").removeClass("show fade-in");

                $(this).find(".mobile-menu-sub-level-panel").scrollTop(0);

                $(this).find(".js-menu-back-btn").data("depth-level", 0);
            });

        let mobileMenuBackBtnWrap = $("#header-navbar-menu-wrapper").find(
            ".back-btn-wrap"
        );
        let mobileMenuBackBtn =
            mobileMenuBackBtnWrap.children(".js-menu-back-btn");

        mobileMenuBackBtn.data("depth-level", 0);

        mobileMenuBackBtn.on("click", function () {
            $(this).data("depth-level", $(this).data("depth-level") - 1);

            let currentMenuPanel = $("#header-navbar-menu-wrapper").find(
                ".mobile-menu-sub-level-panel.curr-level"
            );

            currentMenuPanel
                .parent()
                .closest(".mobile-menu-sub-level-panel")
                .addClass("curr-level");

            currentMenuPanel
                .addClass("fade-out")
                .removeClass("show fade-in curr-level");

            if ($(this).data("depth-level") <= 0) {
                $("#header-navbar-menu-wrapper")
                    .find(".header-navbar-menu-inner-wrap")
                    .addClass("curr-level");

                $(this)
                    .data("depth-level", 0)
                    .parent()
                    .addClass("fade-out")
                    .removeClass("show fade-in");
            }
        });

        $("#header-navbar-menu-wrapper")
            .find(".navbar-nav .menu-item.menu-item-has-children > .nav-link")
            .on("click", function (evt) {
                evt.preventDefault();

                $("#header-navbar-menu-wrapper")
                    .find(".curr-level")
                    .removeClass("curr-level");

                $(this)
                    .siblings(".mobile-menu-sub-level-panel")
                    .scrollTop(0)
                    .removeClass("fade-out")
                    .addClass("show fade-in curr-level");

                if (mobileMenuBackBtn.data("depth-level") === 0) {
                    mobileMenuBackBtnWrap
                        .removeClass("fade-out")
                        .addClass("show fade-in");
                } else {
                    $(this)
                        .siblings(".mobile-menu-sub-level-panel")
                        .css(
                            "top",
                            $(this)
                                .closest(
                                    ".mobile-menu-sub-level-panel, .header-navbar-menu-inner-wrap"
                                )
                                .scrollTop()
                        );
                }

                mobileMenuBackBtn.data(
                    "depth-level",
                    mobileMenuBackBtn.data("depth-level") + 1
                );

                return false;
            });

        // stop YouTube video in the pop-up when the pop-up is closed
        const popupContainer = document.querySelector(".pum-container");

        if (popupContainer) {
            popupContainer
                .querySelector("button.pum-close")
                .addEventListener("click", stopYTVideo);
        }

        function stopYTVideo() {
            const youtubeIframe = popupContainer.querySelector("iframe");

            if (youtubeIframe) {
                const iframeSrc = youtubeIframe.src;
                //reset the source to stop the video
                youtubeIframe.src = iframeSrc;
            }
        }
    });
})(jQuery);
